<template>
  <footer class="bg-secondary bg-dk d-flex justify-content-center footer">
    <p class="text-light mt-2 mb-2">© MangoSTEEMS Universe</p>
  </footer>
</template>

<script>
export default {};
</script>

<style>
</style>